import React from "react";

/**
 * Small green circular check badge used in the trust row (matches the design:
 * #e6f7ed circle, #1f6b3f check).
 */
const CheckBadge = () => (
    <span className="registration-check-badge" aria-hidden>
        <svg
            width="10"
            height="10"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M20 6 9 17l-5-5" />
        </svg>
    </span>
);

export default CheckBadge;
